
import { defineComponent, reactive, toRefs } from 'vue'
import ListHandler from '@/utils/tool/ListHandler'
import { toTop } from '@/utils/tool/Tool'
import { useRouter } from 'vue-router'

export default defineComponent({
    setup() {
        const router = useRouter()
        const state = reactive({
            tagList: [] as string[],
            selectedTags: [] as string[]
        })
        const _listCompiler = ListHandler.listCompiler({banPagination: true})
        state.tagList = ListHandler.getAllPostTag()

        const tapTag = (tag:string) => {
            if (!tag) return 
            const idx = state.selectedTags.indexOf(tag)
            if ( idx >= 0) {
                state.selectedTags.splice(idx,1)
            } else {
                state.selectedTags.push(tag)
            }
            _listCompiler.reloadList({
                tags: state.selectedTags
            })
        }

        const tapAll = () => {
            state.selectedTags = []
            _listCompiler.reloadList()
        }

        const tapPost = (name:string) => {
            if (!name) return 
            toTop()
            router.push(`/post?file=${name}`)
        }

        return {
            ...toRefs(state),
            ..._listCompiler,
            tapPost,
            tapTag,
            tapAll
        }
    }
})
